module.exports = __webpack_public_path__ + "static/logo_sony-121320aa878dcf88132a0aaf829fd105.png";